import Vue from 'vue';

export default {
  namespaced: true,

  state: {
    preinvoice: null,
  },

  getters: {
    getPreinvoice(state) {
      return state.preinvoice;
    },

    getInitialQuotationSubtotal(state) {
      const initialQuotationSubtotal = state.preinvoice ? state.preinvoice.services[0].subtotal : 0;
      return initialQuotationSubtotal.toFixed(2);
    },

    getInitialQuotationTaxes(state) {
      const initialQuotationTaxes = state.preinvoice ? state.preinvoice.services[0].taxesAmount : 0;
      return initialQuotationTaxes.toFixed(2);
    },
  },

  mutations: {
    SET_PREINVOICE(state, payload) {
      Vue.set(state, 'preinvoice', payload);
    },
  },
};
